import { Grid, Typography, Link } from '@material-ui/core';
import React from 'react';
import { LocationViewModel } from '../../model/LocationViewModel';
import FormGridCell from '../common/FormGridCell';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { makeStyles, createStyles } from '@material-ui/styles';
import LanguageList from '../common/language/LanguageList';

type ExamSessionLocationFieldsProps = {
  location: LocationViewModel;
}
  & WrappedComponentProps;

const useStyles = makeStyles(theme => (createStyles({
  language: {
    marginRight: '10px',
  },
  root: {
    marginLeft: '4px'
  },
})));

const ExamSessionLocationFields: React.FunctionComponent<ExamSessionLocationFieldsProps> = ({ intl, location }) => {
  const cssClasses = useStyles({});

  return (
    <Grid container={true} spacing={1} className={cssClasses.root}>
      <FormGridCell size='medium'>
        <Grid>
          <FormGridCell size='full'>
            <Typography variant="body1">{location.street}</Typography>
          </FormGridCell>
          <FormGridCell size='full'>
            <Typography variant="body1">{location.zipCode} {location.city}</Typography>
          </FormGridCell>
          <FormGridCell size='full'>
            <Typography variant="body1">{location.canton}</Typography>
          </FormGridCell>
        </Grid>
      </FormGridCell>
      <FormGridCell size='medium'>
        <Typography variant="body1"><LanguageList languageRegions={location.languageRegions} /></Typography>
      </FormGridCell>
      <FormGridCell size='medium'>
        <Grid>
          <FormGridCell size='full'>
            <Typography variant="body1">{location.contactName}</Typography>
          </FormGridCell>
          <FormGridCell size='full'>
            <Typography variant="body1"><Link underline="always" href={`mailto:${location.contactEmailAddress}`}>{location.contactEmailAddress}</Link> </Typography>
          </FormGridCell>
          <FormGridCell size='full'>
            <Typography variant="body1">{location.contactPhoneNo}</Typography>
          </FormGridCell>
        </Grid>
      </FormGridCell>
    </Grid>
  );
}

ExamSessionLocationFields.defaultProps = {
  onChangeEmailIsValid: () => { },
  onPropertyValueChanges: () => { },
  readOnly: false
} as Partial<ExamSessionLocationFieldsProps>;

export default injectIntl(ExamSessionLocationFields);
